var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ace-editor',{attrs:{"value":_vm.value,"lang":"javascript","theme":"chrome","height":"300px"},on:{"input":function($event){return _vm.$emit('input', $event)},"init":_vm.editorInit}})}
var staticRenderFns = []

export { render, staticRenderFns }